import script from "./model.vue?vue&type=script&setup=true&lang=js"
export * from "./model.vue?vue&type=script&setup=true&lang=js"

import "./model.vue?vue&type=style&index=0&id=2f3e8bcc&lang=css"
import "./model.vue?vue&type=style&index=1&id=2f3e8bcc&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3e8bcc"]])

export default __exports__